export const HOME_PAGE_GAMES_AMOUNT = 14;

export const GAME_PER_PAGE = 30;

export const GROUPS = {
  CASINO: 'CASINO',
  LIVE: 'LIVE',
  TVGAMES: 'TVGAMES',
};

export const GAME_SIZES = {
  LARGE: 'L',
  MEDIUM: 'M',
  SMALL: 'S',
};
